// Shared "Powered by Tradermap.io" attribution shown on every lightweight-
// charts instance in the app. Sits next to the lightweight-charts
// "Charting by TradingView" anchor (bottom-left), separated by a middle
// dot so the two attributions read as a pair, not as competing labels.
//
// Pointer-events disabled so the watermark never intercepts tooltips,
// crosshair, or the mark-price overlays drawn over the chart.

import React from 'react';
import './ChartWatermark.css';

function ChartWatermark() {
  return (
    <div className="chart-watermark" aria-hidden="true">
      <span className="chart-watermark__sep">·</span>
      <span className="chart-watermark__text">
        Powered by <strong>Tradermap.io</strong>
      </span>
    </div>
  );
}

export default React.memo(ChartWatermark);
